<!-- Storyblok dynamic component -->
<section class="column-content-wrapper" [appStoryblokEditable]="_editable" *ngIf="blocks?.length && COMPONENTS">
  <div class="column" *ngFor="let blok of blocks" [appStoryblokEditable]="blok._editable">
    <ndc-dynamic [ndcDynamicComponent]="COMPONENTS[blok.component]" [ndcDynamicInputs]="blok"> </ndc-dynamic>
  </div>
</section>
